<template>
    <v-card flat tile>
        <v-card-title class="align-center justify-space-between wrap">
            <v-flex xs8 pa-0>
                <slot name="title">Title</slot>
            </v-flex>
            <v-flex pa-0 text-xs-right xs4>
                <div v-show="multiViewsBtnStatus">
                    <v-icon
                            :disabled="currentView === 1"
                            @click="move('backward')"
                            color="bindezcolor"
                            small
                    >
                        fas fa-chevron-left
                    </v-icon>
                    <v-icon
                            :disabled="currentView === totalViews"
                            @click="move('forward')"
                            class="ml-4"
                            color="bindezcolor"
                            small

                    >
                        fas fa-chevron-right
                    </v-icon>
                </div>
            </v-flex>
            <v-flex xs12 pa-0>
                <v-text-field
                        v-if="searchable"
                        :clearable="true"
                        @click:clear="searchListItems"
                        @keyup.enter="searchListItems"
                        background-color="#f4f4f4"
                        class="search-box--height mb-0 mt-3"
                        flat
                        height="41"
                        hide-details
                        placeholder="Search Here"
                        solo
                        v-model="search"
                />
            </v-flex>
        </v-card-title>
        <template v-if="ready">
            <div class="d-flex align-center fill-height" :style="{height: `${notFoundSectionHeight}px`}" v-if="listItems.length < 1">
                <span class="text-xs-center subheading font-weight-bold" style="color:#AFBAC8;">
                    <slot name="no-items">No Items Found</slot>
                </span>
            </div>
            <slot :list-view="keywordsPerView" name="list-item"></slot>
        </template>
        <div class="d-flex align-center fill-height" style="height: 300px;" v-else>
            <v-progress-circular
                    color="bindezcolor"
                    indeterminate
            />
        </div>
    </v-card>
</template>

<script>
	import chunk from 'lodash/chunk';
	import authCurrentUser from "@/mixins/authCurrentUser";
	import multiViews from "@/mixins/multiViews";

	export default {
		props: {
			listItems: {
				type: Array,
				required: true,
				default() {
					return [];
				}
			},
			searchBy: {
				type: String,
				required: true,
			},
			ready: {
				type: Boolean,
				required: true,
			},
			itemPerPage: {
				type: Number,
				required: true
			},
			searchable: {
				type: Boolean,
				default: false,
			},
            notFoundSectionHeight:{
				type:Number,
                default: 300
            }
		},
		data() {
			return {
				search:undefined,
            }
		},
		name: "AppSearchComponent",
		mixins: [multiViews, authCurrentUser],
		methods: {
			searchListItems(event) {
				this.currentView = 1;
				let filterPaged = event && event.type === 'keyup' ? this.listItems.filter(item => item[this.searchBy].toLowerCase().includes(this.search.toLowerCase())) : this.listItems;
				this.totalViews = Math.ceil(filterPaged.length / this.itemPerPage);
				this.allKeywords = chunk(filterPaged, this.itemPerPage);
				this.keywordsView = this.allKeywords[0];
			}
		},
		watch: {
			listItems: {
				handler: 'searchListItems',
				immediate: true,
			}
		}

	}
</script>

<style scoped>

</style>
